import { render, staticRenderFns } from "./LangCode.vue?vue&type=template&id=10c5e128"
import script from "./LangCode.vue?vue&type=script&lang=js"
export * from "./LangCode.vue?vue&type=script&lang=js"
import style0 from "./LangCode.vue?vue&type=style&index=0&id=10c5e128&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports